// 生产环境域名映射
export default {
    'ProxyLogin': process.env.PASSPORT_URL,
    'ProxyLapi': process.env.GATEWAY_URL,
    'ProxyApi': process.env.WEB_API_DOMAIN,
    'ProxyAdmin': location.origin,
};
